import { useQuery } from "@tanstack/react-query";
import { useInfiniteQuery } from "@tanstack/react-query";
import api from "apis";
import {
  GetPushNotificationPageParams,
  GetUnreadPushNotificationCountParams,
} from "apis/data-contracts";

// 푸시 알림 리스트 조회
export const useGetPushNotification = (
  params: GetPushNotificationPageParams,
) => {
  return useInfiniteQuery({
    queryKey: api.pushNotification.getPushNotificationPageKey(params),
    queryFn: ({ pageParam }) =>
      api.pushNotification.getPushNotificationPage({
        ...params,
        pushNotificationId: pageParam ?? undefined,
      }),
    select: (data) => data.pages.flatMap((page) => page.data.result.contents),
    initialPageParam: params.pushNotificationId ?? null,
    getNextPageParam: (lastPage) => {
      if (lastPage.data.result.hasNextPage) {
        return lastPage.data.result.contents[
          lastPage.data.result.contents.length - 1
        ].id;
      }
      return undefined;
    },
  });
};

// 읽지 않은 푸시 알림 개수 조회
export const useGetUnreadPushNotificationCount = (
  params: GetUnreadPushNotificationCountParams,
) => {
  return useQuery({
    queryKey: api.pushNotification.getUnreadPushNotificationCountKey(params),
    queryFn: () => api.pushNotification.getUnreadPushNotificationCount(params),
  });
};
